import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroListaPreCadastroCliente {
  lastSetDefault: Date;
  page: number;
  order: string;

  NCODIGO: number | null;
  CSTATUS: string;
  CSTATUS_IN: Array<string> | string;
  DINCLUSAO_DE: Date;
  DINCLUSAO_ATE: Date;
  CURGENTE: string;
  CUSUARIO: string;

}

export class FiltroListaPreCadastroCliente {

  dados: IFiltroListaPreCadastroCliente;
  storageName: string;

  CSTATUSlista = [
    { value: '1', label: 'Engenharia'},
    { value: '2', label: 'Engenharia Negado'},
    { value: '3', label: 'Controladoria'},
    { value: '4', label: 'Controladoria Negado'},
    { value: '5', label: 'Diretoria'},
    { value: '6', label: 'Diretoria negado'},
    { value: '7', label: 'Finalizado'},
    { value: 'A', label: 'Cancelado'}
  ];

  CURGENTElista = [
    { value: ' ', label: 'Todos'},
    { value: 'S', label: 'Sim'},
    { value: 'N', label: 'Não'},
  ];

  constructor(private poStorageService: PoStorageService, storageName: string = 'filtro-lista-pre-cliente') {
    this.dados = this.setDefault();
    this.storageName = storageName;

    this.poStorageService.get(this.storageName).then((filtro: IFiltroListaPreCadastroCliente) => {
        if (filtro) {
          const {
            lastSetDefault,
            DINCLUSAO_DE,
            DINCLUSAO_ATE,
            CSTATUS_IN,
          } = filtro;

          if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
            this.dados = this.setDefault();
          } else {
            this.dados = {
              ...filtro,
              lastSetDefault: new Date(lastSetDefault),
              DINCLUSAO_DE: new Date(DINCLUSAO_DE),
              DINCLUSAO_ATE: new Date(DINCLUSAO_ATE),
              CSTATUS_IN: CSTATUS_IN?.length ? CSTATUS_IN : CSTATUS_IN.toString(),
            };
          }
        }
      });
  }

  public setDefault = (): IFiltroListaPreCadastroCliente => {
    return {
      lastSetDefault: new Date(),
      page: 1,
      order: '',

      NCODIGO: null,
      CSTATUS: ' ',
      CSTATUS_IN: '',
      DINCLUSAO_DE: this.getData(-365),
      DINCLUSAO_ATE: new Date,
      CURGENTE: ' ',
      CUSUARIO: '',

    };
  };

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  };

  private getData = (dias: number): Date => {
    const data = new Date();
    data.setDate(data.getDate() + dias);
    return data;
  }

}
